import {
  BULK_REQUEST_REQUEST_TASKS_STATUS__FETCH_FAILURE,
  BULK_REQUEST_REQUEST_TASKS_STATUS__FETCH_REQUEST,
  BULK_REQUEST_REQUEST_TASKS_STATUS__FETCH_SUCCESS,
} from '@app/store/actionTypes';
import AllStatusResponse from '@app/store/transport-layer/bulk-request/bulk-requests/request-tasks/all/status/AllStatusResponse';

export function fetchRequestTasksStatus(payload: string) {
  return {
    type: BULK_REQUEST_REQUEST_TASKS_STATUS__FETCH_REQUEST,
    payload,
  };
}

export function fetchRequestTasksStatusSuccess(payload: AllStatusResponse) {
  return {
    type: BULK_REQUEST_REQUEST_TASKS_STATUS__FETCH_SUCCESS,
    payload,
  };
}

export function fetchRequestTasksStatusFailure(payload: Error) {
  return {
    type: BULK_REQUEST_REQUEST_TASKS_STATUS__FETCH_FAILURE,
    payload,
    error: true,
  };
}

export type StatusAction =
  | ReturnType<typeof fetchRequestTasksStatus>
  | ReturnType<typeof fetchRequestTasksStatusSuccess>
  | ReturnType<typeof fetchRequestTasksStatusFailure>;
